import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { clearStoredSession, HOME_ROUTE, isTokenValid, markSessionExpired } from "../utils/session";

const PrivateRoute = ({ children }) => {
  const token = localStorage.getItem("token");
  const hasValidSession = isTokenValid(token);
  const { requiresTratamientoDatos } = useAuth();

  if (!hasValidSession) {
    if (token) {
      clearStoredSession();
      markSessionExpired();
    }
    return <Navigate to={HOME_ROUTE} replace />;
  }

  if (requiresTratamientoDatos) {
    return null;
  }

  return children;
};

export default PrivateRoute;
